<template>
    <div class="content">
        <p class="title">围绕采购、生产、质量、设备等关键环节，为企业提供智改数转服务，助力企业提质降本增效</p>
        <div class="block_div flex">
            <div class="flex block_div_item" v-for="item in list" :key="item.title">
                <img :src="item.url" alt="" srcset="" class="block_div_item_img">
                <!-- <p class="item_title">{{ item.title }}</p> -->
                <p class="item_content">{{ item.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    url: require("@/assets/home/1_1.png"),
                    url1: require("@/assets/home/1_2.png"),
                    text: '实现账料相符，供销匹配，降低库存堆积，提升盘点效率及资金利用效率；'
                },
                {
                    url: require("@/assets/home/2_1.png"),
                    url1: require("@/assets/home/2_2.png"),
                    text: '生产过程数据实时查看，准确、快速统计绩效、产出和成本，减少人工统计时间；'
                },
                {
                    url: require("@/assets/home/3_1.png"),
                    url1: require("@/assets/home/3_2.png"),
                    text: '生产数据统一、规范、标准的管理，减少信息处理错漏和缺失问题，形成结果和统计报表，方便效率；'
                },
                {
                    url: require("@/assets/home/4_1.png"),
                    url1: require("@/assets/home/4_2.png"),
                    text: '通过RFID自动识别技术智能获取产品信息，实现对物品高效、准确、自动化追踪和管理。'
                }
            ]
        }
    },
    created() { },
    methods() { },
}

</script>
<style lang="less" scoped>
.content {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
        width: 1200px;
        height: 40px;
        font-size: 24px;
        font-family: ABCMarfa-Bold, ABCMarfa;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
        margin-bottom: 15px;
    }

    .sub-title {
        width: 864px;
        height: 44px;
        margin-top: 16px;
        font-size: 16px;
        font-family: ABCMarfa-Bold, ABCMarfa;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
    }

    .block_div {
        margin-top: 40px;
        align-items: flex-start;
    }

    .block_div_item {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 260px;

        img {
            width: 120px;
            height: 120px;
            object-fit: contain;
            margin-bottom: 30px;
            transition: all 0.6s;
            &:hover {
                transform: scale(1.2);
            }
        }

        .item_title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6E6E;
            line-height: 28px;
            margin-bottom: 16px;
        }

        .item_content {
            font-size: 14px;
            font-family: ABCMarfa-Bold, ABCMarfa;
            font-weight: 400;
            color: #000000;
            line-height: 28px;
        }

        p {
            text-align: left;

        }
    }

    .block_div_item {
        margin-right: 54px;

    }

    .block_div_item:last-child {
        margin-right: 0;
    }
}</style>


// WEBPACK FOOTER //
// src/components/homeIndex/digitizationProd.vue